import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBSGO8FMx4Kuit7Ka37vKT84bDNjSWtvOs",
  authDomain: "ats-airfield-express.firebaseapp.com",
  projectId: "ats-airfield-express",
  storageBucket: "ats-airfield-express.firebasestorage.app",
  messagingSenderId: "34324623661",
  appId: "1:34324623661:web:3ac0c9ec9b534f20e0e3a4",
};

const app = initializeApp(firebaseConfig);

let messaging: Messaging | null = null;
try {
  if (typeof window !== "undefined" && "Notification" in window && "serviceWorker" in navigator) {
    messaging = getMessaging(app);
  }
} catch (err) {
  console.warn("Firebase Messaging not supported in this browser:", err);
}

export { messaging };

export const requestNotificationPermission = async (): Promise<{ token: string | null; status: NotificationPermission | "unsupported" }> => {
  if (!messaging || !("Notification" in window)) {
    return { token: null, status: "unsupported" };
  }
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BCtX13LvgQgZc_8y7_ZPcvxzaFMaRy4X57VC04il0ReUlRvqf1navdekTopum9F0MSd2Dtb2Iu3-l-nm5qGUw5Q",
      });
      return { token, status: "granted" };
    }
    return { token: null, status: permission };
  } catch (err) {
    console.warn("FCM token retrieval failed:", err);
    return { token: null, status: "unsupported" };
  }
};

export { onMessage };
export default app;
